import request from '@/utils/request'

export function add(data) {
    return request({
        url: '/api/resumeBaseInfo/add',
        method: 'post',
        data
    })
}




export function existResume() {
    return request({
        url: '/api/resumeBaseInfo/existResume',
        method: 'get'
    })
}



export function getUserResume() {
    return request({
        url: '/api/resumeBaseInfo/getUserResume',
        method: 'get'
    })
}

// export function getResumeRecords() {
//     return request({
//         url: '/api/resumeBaseInfo/getUserResume',
//         method: 'get'
//     })
// }

export function getResumeRecords() {
    return request({
        url: '/api/resumeBaseInfo/getStatusRecords',
        method: 'get'
    })
}







// WEBPACK FOOTER //
// ./src/api/resume.js